import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useTheme } from 'vuetify';

export default () => {
  const store = useStore();
  const theme = useTheme();
  const conn = store.getters.getDBConnection;
  const dataLoaded = computed(() => store.getters.getDataLoaded);

  // Load permission rules from DuckDB directly
  const permissionRulesObj = ref({});

  const loadPermissionRulesFromDB = async () => {
    if (!dataLoaded.value) return;

    try {
      const result = await conn.query('SELECT * FROM permission_rules');
      const rows = result.toArray();

      // The permission_rules table has a nested structure where each column is a teamId
      // containing an array of permission rules.
      if (rows.length > 0) {
        const row = rows[0];
        const rowJson = row.toJSON();

        const rules = {};
        // Each key in the row is a teamId, and the value is a Vector of rules
        for (const teamId of Object.keys(rowJson)) {
          const teamRulesVector = rowJson[teamId];
          // Convert Vector to array
          const teamRulesArray = [];
          if (teamRulesVector && typeof teamRulesVector.toArray === 'function') {
            const rulesArray = teamRulesVector.toArray();
            rulesArray.forEach(rule => {
              const ruleObj = typeof rule.toJSON === 'function' ? rule.toJSON() : rule;
              let permissionOptions = ruleObj.permissionOptions || ruleObj.PermissionOptions || [];
              let permissionConditions = ruleObj.permissionConditions || ruleObj.PermissionConditions || [];

              if (typeof permissionOptions === 'string') {
                try { permissionOptions = JSON.parse(permissionOptions); } catch { permissionOptions = []; }
              }
              if (typeof permissionConditions === 'string') {
                try { permissionConditions = JSON.parse(permissionConditions); } catch { permissionConditions = []; }
              }

              teamRulesArray.push({
                action: ruleObj.action || ruleObj.Action,
                permissionOptions: Array.isArray(permissionOptions) ? permissionOptions : [],
                permissionConditions: Array.isArray(permissionConditions) ? permissionConditions : []
              });
            });
          }
          if (teamRulesArray.length > 0) {
            rules[teamId] = teamRulesArray;
          }
        }
        permissionRulesObj.value = rules;
      }
    } catch (error) {
      console.error('Error loading permission rules from DB:', error);
    }
  };

  const backgroundColor = computed(() => {
    return theme.global.name.value === 'dark' ? '#192b35' : '#eeeeee';
   });

  const activeTab = ref('overview');

  const assignableTeamIds = computed(() => {
    const result = {};

    Object.entries(permissionRulesObj.value).forEach(([teamId, rules]) => {
      const hasIssueAssign = rules.some(rule =>
        rule.action === 'issueAssign' &&
        rule.permissionOptions.length === 0 &&
        rule.permissionConditions.length === 0
      );

      const hasFormAssign = rules.some(rule =>
        rule.action === 'formAssign' &&
        rule.permissionOptions.length === 0 &&
        rule.permissionConditions.length === 0
      );

      result[teamId] = hasIssueAssign && hasFormAssign;
    });

    return result;
  });



  const assignmentAllowed = computed(() => {
    return Object.values(assignableTeamIds.value).some(value => value === true);
  });

  // Watch for dataLoaded to become true
  watch(dataLoaded, async (newValue) => {
    if (newValue) {
      await loadPermissionRulesFromDB();
    }
  }, { immediate: true });

  onMounted(async () => {
    await store.commit('resetFilters');
  });

  return {
    backgroundColor,
    activeTab,
    assignableTeamIds,
    assignmentAllowed
  };
};
